"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoNodesFoundException = void 0;
const string_1 = require("../../../helpers/string");
class NoNodesFoundException extends Error {
    static CODE = 'NO_NODES_FOUND_FOR_CHAIN';
    static MESSAGE = 'No nodes found for chain ??';
    constructor(chainName) {
        super((0, string_1.formatString)(NoNodesFoundException.MESSAGE, chainName));
        this.name = NoNodesFoundException.CODE;
    }
}
exports.NoNodesFoundException = NoNodesFoundException;
